const available = [
  88004,
  88001,
  88002,
  88003,
  9933,
  99141,
  99144,
  99145,
  99146,
  99147,
  99148,
  99149,
  99177,
  99229,
  99281,
  99298,
  99332,
  99479,
  99543,
  99580,
  99849,
  99850,
  99875,
  99940,
  99986,
  991076,
  991146,
  991284,
  991285,
  991334,
  991380,
  991381,
  991402,
  991675,
  991685,
  992529,
  992535,
  992536,
  992598,
  993017,
  993338,
  993628,
  993701,
  993783,
  993942,
  993991,
  994067,
  994283,
  994500,
  994624,
  995357,
  995678,
  995679,
  995782,
  995850,
  9922020,
  9922036,
  9922037,
  994037,
  994055,
  99345,
  993657,
  993677,
  993658,
  992107,
  995039,
  992851,
  993435,
  994791,
  995367,
  995380,
  995038,
  991339,
  991353,
  991383,
  991389,
  991400,
  993378,
  9915,
  9981,
  9982,
  99173,
  99182,
  99288,
  99702,
  99805,
  99981,
  991134,
  992766,
  992779,
  993535,
  993742,
  993743,
  994622,
  994880,
  995669,
  9921955,
  9921956,
  13,
  12,
  9980,
  99153,
  99174,
  99192,
  99217,
  99453,
  99546,
  99550,
  99616,
  99699,
  99776,
  991153,
  991155,
  991159,
  991161,
  991162,
  991234,
  991251,
  991252,
  991596,
  991672,
  992397,
  992724,
  992891,
  993177,
  993565,
  993662,
  993765,
  993925,
  994419,
  994621,
  994857,
  994874,
  995122,
  995249,
  995539,
  995660,
  995676,
  995755,
  995860,
  995861,
  995883,
  995947,
  9921863,
  9921946,
  9922022,
  99701,
  9,
  27,
  994563,
  995540,
  995549,
  24,
  994371,
  9976,
  992004,
  992806,
  993197,
  993237,
  994472,
  9921865,
  9921866,
  991396,
  991397,
  993324,
  994298,
  994557,
  994962,
  992762,
  99327,
  99511,
  99513,
  99517,
  99897,
  991088,
  992011,
  992012,
  992013,
  992014,
  992015,
  992016,
  992020,
  992749,
  992925,
  993972,
  995139,
  995154,
  995447,
  9915761,
  9915763,
  993217,
  15,
  992464,
  994864,
  993377,
  993379,
  994263,
  992088,
  993432,
  992884,
  994792,
  994793,
  99665,
  99799,
  991154,
  991157,
  992324,
  992605,
  992641,
  992725,
  992736,
  992738,
  992761,
  992845,
  993425,
  993731,
  994696,
  995375,
  99219,
  99564,
  99595,
  99797,
  991053,
  991054,
  991110,
  991148,
  991149,
  991152,
  991249,
  991326,
  991477,
  992722,
  993014,
  993100,
  993461,
  993678,
  993736,
  993756,
  993929,
  994026,
  994034,
  994335,
  994360,
  994805,
  994848,
  995109,
  995687,
  995715,
  995716,
  995728,
  995729,
  995873,
  9921919,
  9921920,
  9922023,
  9938,
  99168,
  99589,
  991150,
  991151,
  992359,
  993266,
  993330,
  993671,
  993883,
  993966,
  994933,
  995165,
  995205,
  993907,
  992910,
  994588,
  994982,
  994983,
  994378,
  991829,
  991831,
  993474,
  994282,
  995919,
  991337,
  991338,
  992886,
  993400,
  994176,
  993026,
  18,
  99129,
  99195,
  99196,
  99239,
  99240,
  99277,
  99336,
  99338,
  99721,
  991046,
  991059,
  991078,
  991247,
  991646,
  991691,
  991693,
  992613,
  992624,
  992654,
  993141,
  993373,
  993705,
  993706,
  993802,
  993930,
  994506,
  994552,
  994951,
  994958,
  995321,
  995423,
  995425,
  995730,
  995739,
  995767,
  995787,
  9921981,
  9921983,
  9921985,
  9922025,
  991236,
  991407,
  993081,
  993730,
  993941,
  994338,
  994342,
  994355,
  994356,
  994517,
  994712,
  995120,
  995242,
  995405,
  995735,
  995738,
  14,
  991375,
  991379,
  994259,
  994560,
  995567,
  995717,
  11,
  991811,
  995189,
  10,
  991342,
  992649,
  992650,
  993833,
  993834,
  994363,
  995741,
  995742,
  995743,
  995744,
  995745,
  995746,
  995748,
  991485,
  994807,
  991313,
  991315,
  991316,
  991320,
  993889,
  994358,
  995162,
  995358,
  995693,
  995737,
  993285,
  994470,
  995858,
  994379,
  993463,
  994244,
  994306,
  994574,
  994955,
  7,
  8,
  991807,
  991808,
  993728,
  995664,
  992885,
  992887,
  994720,
  995593,
  26,
  991321,
  991322,
  991323,
  991324,
  991330,
  991399,
  993445,
  993887,
  993888,
  994357,
  995164,
  995356,
  995692,
  995289,
  994605,
  993456,
  994789,
  9961,
  992036,
  992473,
  992794,
  992795,
  992797,
  994147,
  994322,
  994788,
  993905,
  994644,
  995011,
  994770,
  994771,
  994917,
  993831,
  995170,
  994748,
  994750,
  994751,
  995547,
  995893,
  995944,
  28,
  993464,
  994245,
  994304,
  994575,
  994956,
  994594,
  993660,
  994480,
  995171,
  992740,
  991543,
  991544,
  993488,
  992021,
  992028,
  993661,
  993827,
  993828,
  993829,
  9919314,
  992652,
  992653,
  993346,
  993835,
  9921750,
  991592,
  991593,
  991594,
  993652,
  995012,
  992090,
  993313,
  993322,
  992084,
  993670,
  993825,
  994289,
  995126,
  992026,
  992631,
  992946,
  992947,
  995411,
  992029,
  993838,
  993840,
  994196,
  994593,
  995545,
  993669,
  993830,
  993832,
  9919316,
  995594,
  995595,
  993727,
  993735,
  994228,
  995590,
  995592,
  992089,
  994948,
  992039,
  993430,
  993480,
  993004,
  995221,
  9914057,
  9914059,
  9914074,
  9914081,
  9914091,
  9916433,
  9917294,
  9917300,
  9917439,
  9917440,
  9917462,
  9917599,
  9917638,
  9918549,
  9918820,
  9919752,
  9920157,
  9920322,
  9921650,
  9921651,
  9921652,
  9921653,
  9921684,
  9921685,
  9921686,
  9921687,
  9921715,
  9921716,
  9921717,
  9921737,
  9921947,
  9921952,
  992647,
  992648,
  993082,
  993168,
  994601,
  995176,
  995177,
  995490,
  9915778,
  9915786,
  9915792,
  9915798,
  9917413,
  9917415,
  9917418,
  9917433,
  9917434,
  9917437,
  9917705,
  9918961,
  9918980,
  9918981,
  9919309,
  9919311,
  9919669,
  9921101,
  9921567,
  9921624,
  9921628,
  9921636,
  9921793,
  9921794,
  9921800,
  9921802,
  9921803,
  9921806,
  9921808,
  9921810,
  9921817,
  993630,
  994796,
  993037,
  994703,
  995117,
  995118,
  992729,
  995254,
  9915772,
  9917695,
  992091,
  991772,
  991773,
  995352,
  992087,
  993111,
  993115,
  994572,
  9913947,
  9913952,
  9913955,
  9913956,
  9913957,
  9914062,
  9914078,
  9916193,
  9916282,
  9916286,
  9916287,
  9916289,
  9917454,
  9917458,
  9917470,
  9917478,
  9917480,
  9917481,
  9917573,
  9917574,
  9917578,
  9917727,
  9918330,
  9918953,
  9918962,
  9919774,
  9919888,
  9919911,
  9919913,
  9919914,
  9920099,
  9920123,
  9920258,
  9920625,
  9921157,
  9921171,
  9921186,
  9921187,
  9921571,
  9921671,
  9921674,
  9917847,
  9921541,
  994587,
  9914025,
  9914029,
  9916416,
  9916482,
  9916483,
  9917594,
  9919788,
  9919892,
  9919893,
  9920368,
  9920375,
  9921635,
  9921638,
  9921921,
  995008,
  9913886,
  9916288,
  9916290,
  9916390,
  9916396,
  9916397,
  9916501,
  9916968,
  9917229,
  9917234,
  9917237,
  9917238,
  9917239,
  9918738,
  9920619
];

export default [
  {
    value: 88004,
    label: 'BQDM',
    states: ['ny']
  },
  {
    value: 88001,
    label: 'Non-Wires Alternative (Williamsburg)',
    states: ['ny']
  },
  {
    value: 88002,
    label: 'Non-Wires Alternative (Prospect Park)',
    states: ['ny']
  },
  {
    value: 88003,
    label: 'Non-Wires Alternative (Borough Hall)',
    states: ['ny']
  },
  {
    value: 2,
    label: 'Multi-Family Building Incentive',
    states: ['ny']
  },
  {
    value: 3,
    label: 'Demand Response Program',
    states: ['ny']
  },
  {
    value: 4,
    label: 'Solar + Storage',
    states: ['ny']
  },
  {
    value: 5,
    label: 'Demand Management 2.0',
    states: ['ny']
  },
  {
    value: 6,
    label: 'CHP BQDM Incentive',
    states: ['ny']
  },
  {
    value: 7,
    label: 'Commercial Implementation Assistance Program',
    states: ['ny']
  },
  {
    value: 8,
    label: 'Commercial New Construction Program',
    states: ['ny']
  },
  {
    value: 9,
    label: 'Residential New Construction Program',
    states: ['ny']
  },
  {
    value: 10,
    label: 'PON 1746 FlexTech Program',
    states: ['ny']
  },
  {
    value: 11,
    label: 'NY Prize Community Grid Competition (Stage 2)',
    states: ['ny']
  },
  {
    value: 12,
    label: 'Shared Solar',
    states: ['ny']
  },
  {
    value: 13,
    label: 'Residential/Small Commercial Solar',
    states: ['ny']
  },
  {
    value: 14,
    label: 'Commercial/Industrial Solar',
    states: ['ny']
  },
  {
    value: 15,
    label: 'Affordable Solar',
    states: ['ny']
  },
  {
    value: 16,
    label: 'PON 2149 Solar Thermal Incentive Program',
    states: ['ny']
  },
  {
    value: 17,
    label: 'PON 2568 Program',
    states: ['ny']
  },
  {
    value: 18,
    label: 'PON 3309 RTEM',
    states: ['ny']
  },
  {
    value: 19,
    label: 'CST Fuel Cell Program',
    states: ['ny']
  },
  {
    value: 20,
    label: 'Small Wind Turbine Program',
    states: ['ny']
  },
  {
    value: 21,
    label: 'Lighting Upgrade',
    states: ['ny']
  },
  {
    value: 22,
    label: 'Insulation Improvement',
    states: ['ny']
  },
  {
    value: 23,
    label: 'EnergyWise',
    states: ['ny']
  },
  {
    value: 24,
    label: 'Property Tax Exemption',
    states: ['ny']
  },
  {
    value: 25,
    label: 'Solar Energy System Equipment Credit',
    states: ['ny']
  },
  {
    value: 26,
    label: 'Energy Efficiency Tax Incentives',
    states: ['ny']
  },
  {
    value: 27,
    label: 'Energy Efficient Home Credit',
    states: ['ny']
  },
  {
    value: 28,
    label: 'Energy Project Tax Credit',
    states: ['ny']
  },
  {
    value: 1,
    label: 'LED Lighting Free Install',
    states: ['ny']
  },

  {
    value: 995162,
    label:
      'The United Illuminating Company - ZREC and LREC Long Term Contracts',
    states: ['ct']
  },
  {
    value: 995120,
    label: 'Residential Solar Investment Program',
    states: ['ct']
  },
  {
    value: 995738,
    label: '(Electric and Gas) Residential Rebate Program',
    states: ['ct']
  },
  {
    value: 994958,
    label:
      'Local Option - Building Permit Fee Waivers for Renewable Energy Projects',
    states: ['ct']
  },
  {
    value: 994951,
    label: 'Local Option - Residential Sustainable Energy Program',
    states: ['ct']
  },
  {
    value: 994884,
    label: 'CCEF - Alpha Program',
    states: ['ct']
  },
  {
    value: 994712,
    label: 'Small Business Energy Advantage Loan Program',
    states: ['ct']
  },
  {
    value: 994576,
    label:
      'Energy Efficiency Fund (Gas) - Home Energy Solutions and Performance Programs',
    states: ['ct']
  },
  {
    value: 994572,
    label:
      'Norwich Public Utilities (Gas) - Residential Energy Efficiency Rebate Program',
    states: ['ct']
  },
  {
    value: 994566,
    label: 'Litchfield Hills Region - Business Energy Efficiency Program',
    states: ['ct']
  },
  {
    value: 99277,
    label: 'Net Metering',
    states: ['ct']
  },
  {
    value: 991078,
    label: 'Green Power Purchase Plan',
    states: ['ct']
  },
  {
    value: 991087,
    label: 'CEFIA - Residential Solar PV Rebate Program',
    states: ['ct']
  },
  {
    value: 9921985,
    label: 'Energize Connecticut - Small Business Energy Advantage',
    states: ['ct']
  },
  {
    value: 9913886,
    label: 'United Illuminating Company - Energy Opportunities Program',
    states: ['ct']
  },
  {
    value: 995787,
    label: 'Renewable Energy Investment Fund',
    states: ['ct']
  },
  {
    value: 995767,
    label: 'Xcel Energy - Express Energy Efficiency',
    states: ['ct']
  },
  {
    value: 995739,
    label: '(CHIF) Home Energy Solutions Loan Program',
    states: ['ct']
  },
  {
    value: 995737,
    label: 'Commercial and Industrial Kitchen Equipment Rebate Program',
    states: ['ct']
  },
  {
    value: 991236,
    label: 'Operational Demonstration Program',
    states: ['ct']
  },
  {
    value: 991247,
    label: 'Sales and Use Tax Exemption for Energy-Efficient Products',
    states: ['ct']
  },
  {
    value: 995735,
    label: 'Low Interest Energy Efficiency Loan Program (Electric and Gas)',
    states: ['ct']
  },
  {
    value: 991263,
    label: 'On-Site Renewable DG Program',
    states: ['ct']
  },
  {
    value: 9918738,
    label:
      'United Illuminating Company - Process Reengineering for Increased Manufacturing Efficiency (PRIME)',
    states: ['ct']
  },
  {
    value: 99297,
    label: 'CCEF - Commercial, Industrial, Institutional PV Grant Program',
    states: ['ct']
  },
  {
    value: 9922025,
    label: 'Northeast Energy Efficiency Partnerships - EM&V Forum',
    states: ['ct']
  },
  {
    value: 991313,
    label:
      'The United Illuminating Company - Small Business Energy Advantage Program',
    states: ['ct']
  },
  {
    value: 991314,
    label: 'The United Illuminating Company - Energy Star Incentives Program',
    states: ['ct']
  },
  {
    value: 9921983,
    label: 'Energize Connecticut - Energy Conscious Blueprint',
    states: ['ct']
  },
  {
    value: 991315,
    label:
      'The United Illuminating Company - Energy Conscious Blueprint Grant Program',
    states: ['ct']
  },
  {
    value: 991316,
    label:
      'The United Illuminating Company - Energy Conscious Blueprint Rebate Program',
    states: ['ct']
  },
  {
    value: 991318,
    label:
      'The United Illuminating Company - MotorUp Commercial Rebate Program',
    states: ['ct']
  },
  {
    value: 991319,
    label:
      'The United Illuminating Company - Cool Choice Commercial Energy Efficiency Rebate Program',
    states: ['ct']
  },
  {
    value: 991320,
    label: 'The United Illuminating Company - Energy Opportunities Program',
    states: ['ct']
  },
  {
    value: 991321,
    label:
      'Connecticut Light & Power - Energy Opportunities Efficiency Program',
    states: ['ct']
  },
  {
    value: 991322,
    label: 'Connecticut Light & Power - Commercial Energy Efficiency Rebates',
    states: ['ct']
  },
  {
    value: 991323,
    label:
      'Connecticut Light & Power - Small Business Energy Advantage Program',
    states: ['ct']
  },
  {
    value: 991324,
    label:
      'Connecticut Light & Power - Small Business Energy Advantage Program',
    states: ['ct']
  },
  {
    value: 995730,
    label: 'Multifamily Energy Conservation Loan Program',
    states: ['ct']
  },
  {
    value: 991327,
    label: 'Connecticut Light & Power - Express Rebate Programs',
    states: ['ct']
  },
  {
    value: 991329,
    label: 'The United Illuminating Company - Express Lighting Rebate Program',
    states: ['ct']
  },
  {
    value: 991330,
    label:
      'Connecticut Light & Power - Small Industrial and Commercial Energy Efficiency Loan Program',
    states: ['ct']
  },
  {
    value: 9921981,
    label: 'Eversource - Energy Savings Plan',
    states: ['ct']
  },
  {
    value: 99322,
    label: 'Solar and Wind Contractor Licensing',
    states: ['ct']
  },
  {
    value: 99336,
    label: 'CCEF - Renewable Energy Projects in Pre-Development Program',
    states: ['ct']
  },
  {
    value: 9917239,
    label: 'Southern Connecticut Gas - Operation & Maintenance Program',
    states: ['ct']
  },
  {
    value: 99338,
    label: 'CCEF - Project 150 Initiative',
    states: ['ct']
  },
  {
    value: 99157,
    label: 'Connecticut Clean Energy Fund',
    states: ['ct']
  },
  {
    value: 9917238,
    label: 'Southern Connecticut Gas - Energy Opportunities Program',
    states: ['ct']
  },
  {
    value: 9917237,
    label: 'Southern Connecticut Gas - Energy Conscious Blueprint Program',
    states: ['ct']
  },
  {
    value: 9917234,
    label:
      'Santa  Buckley Energy - Heating, Ventilation, and Air Conditioning Equipment and Service',
    states: ['ct']
  },
  {
    value: 9917229,
    label: 'EnerNOC - Energy Procurement',
    states: ['ct']
  },
  {
    value: 991399,
    label: 'Connecticut Light & Power - Operation and Maintenance Program',
    states: ['ct']
  },
  {
    value: 99128,
    label: 'Alternative Fueled Vehicle Incremental Cost Credit',
    states: ['ct']
  },
  {
    value: 991407,
    label: 'Smart-E loans',
    states: ['ct']
  },
  {
    value: 995693,
    label:
      'The United Illuminating Company - ZREC and LREC Long Term Contracts',
    states: ['ct']
  },
  {
    value: 995692,
    label: 'Connecticut Light & Power - ZREC and LREC Long Term Contracts',
    states: ['ct']
  },
  {
    value: 995684,
    label: 'Connecticut Light & Power - Small ZREC Tariff',
    states: ['ct']
  },
  {
    value: 995683,
    label: 'The United Illuminating Company - Small ZREC Tariff',
    states: ['ct']
  },
  {
    value: 995639,
    label: 'Copy of CT Clean Energy Communities',
    states: ['ct']
  },
  {
    value: 995638,
    label: 'Combined Heat and Power Loan Program',
    states: ['ct']
  },
  {
    value: 995637,
    label: 'Performance based incentive for Combined Heat and Power Program',
    states: ['ct']
  },
  {
    value: 991563,
    label: 'Energy Efficiency Standards for Appliances',
    states: ['ct']
  },
  {
    value: 9916968,
    label: 'Norwich Public Utilities - Commercial Energy Audit',
    states: ['ct']
  },
  {
    value: 995425,
    label: 'Clean Energy On-Bill Financing',
    states: ['ct']
  },
  {
    value: 9920619,
    label: 'Santa Buckley Energy - Lighting Retrofits & Upgrades',
    states: ['ct']
  },
  {
    value: 991619,
    label: 'CT Clean Energy Communities',
    states: ['ct']
  },
  {
    value: 991646,
    label: 'Community Innovations Grant Program',
    states: ['ct']
  },
  {
    value: 9916501,
    label:
      'Northeast Energy Efficiency Council - Building Operator Certification (BOC)',
    states: ['ct']
  },
  {
    value: 991691,
    label: 'DPUC - Capital Grants for Customer-Side Distributed Resources',
    states: ['ct']
  },
  {
    value: 991693,
    label: 'Low-Interest Loans for Customer-Side Distributed Resources',
    states: ['ct']
  },
  {
    value: 991772,
    label: 'Groton Utilities - Residential Energy Efficiency Rebate Program',
    states: ['ct']
  },
  {
    value: 991773,
    label:
      'Groton Utilities - Commercial & Industrial Energy Efficiency Rebate Programs',
    states: ['ct']
  },
  {
    value: 991311,
    label:
      'Connecticut Natural Gas - Energy Conservation Program for State Facilities',
    states: ['ct']
  },
  {
    value: 99721,
    label: 'Fuel Cell Initiative',
    states: ['ct']
  },
  {
    value: 995423,
    label: 'Local Option - Property Tax Exemption for Renewable Energy Systems',
    states: ['ct']
  },
  {
    value: 995405,
    label: 'CT Solar Loan',
    states: ['ct']
  },
  {
    value: 995358,
    label: 'The United Illuminating Company - Small ZREC Tariff',
    states: ['ct']
  },
  {
    value: 995356,
    label: 'Connecticut Light & Power - Small ZREC Tariff',
    states: ['ct']
  },
  {
    value: 995321,
    label: 'Local Option - Commercial PACE Financing',
    states: ['ct']
  },
  {
    value: 995242,
    label: 'Commercial Solar Thermal Incentive Program',
    states: ['ct']
  },
  {
    value: 995213,
    label: 'Combined Heat and Power Pilot Loan Program',
    states: ['ct']
  },
  {
    value: 995212,
    label: 'Combined Heat and Power Grant Program',
    states: ['ct']
  },
  {
    value: 995164,
    label: 'Connecticut Light & Power - ZREC and LREC Long Term Contracts',
    states: ['ct']
  },
  {
    value: 995121,
    label: 'Exemption from Electric Generation Tax',
    states: ['ct']
  },
  {
    value: 992313,
    label: 'Energy Efficiency Fund',
    states: ['ct']
  },
  {
    value: 994552,
    label: 'Sales and Use Taxes for Items Used in Renewable Energy Industries',
    states: ['ct']
  },
  {
    value: 992390,
    label: 'Energy Efficiency Requirements for State Government',
    states: ['ct']
  },
  {
    value: 994517,
    label:
      'Energy Efficiency Fund (Electric and Gas) - Residential Energy Efficiency Financing',
    states: ['ct']
  },
  {
    value: 994506,
    label: 'Renewable Portfolio Standards - Energy Efficiency Component',
    states: ['ct']
  },
  {
    value: 99195,
    label: 'Renewables Portfolio Standard',
    states: ['ct']
  },
  {
    value: 9916397,
    label: 'United Illuminating Company - Retro-Commissioning (RCx)',
    states: ['ct']
  },
  {
    value: 992612,
    label: 'Building Energy Code',
    states: ['ct']
  },
  {
    value: 992613,
    label: 'Sales and Use Tax Exemption for Solar and Geothermal Systems',
    states: ['ct']
  },
  {
    value: 992614,
    label: 'OPM - Replacement Furnace Rebate Program',
    states: ['ct']
  },
  {
    value: 994421,
    label: 'CCEF - ARRA Commercial Solar PV Program',
    states: ['ct']
  },
  {
    value: 992623,
    label: 'Connecticut Light & Power - Summer Saver Rewards',
    states: ['ct']
  },
  {
    value: 992624,
    label: 'Local Option - Property Tax Exemption Cogeneration Systems',
    states: ['ct']
  },
  {
    value: 992625,
    label: 'The United Illuminating Company - Summer Savers Rewards',
    states: ['ct']
  },
  {
    value: 994358,
    label:
      'Connecticut Light & Power - Energy Conscious Blueprint Grant Program',
    states: ['ct']
  },
  {
    value: 994357,
    label:
      'Connecticut Light & Power - Small Business Energy Advantage Loan Program',
    states: ['ct']
  },
  {
    value: 994356,
    label:
      'Energy Efficiency Fund (Electric) - Commercial New Construction Rebate Program',
    states: ['ct']
  },
  {
    value: 994355,
    label: '(Electric) Commercial and Industrial Energy Efficiency Programs',
    states: ['ct']
  },
  {
    value: 994342,
    label: '(Electric and Gas)  Residential New Construction Program',
    states: ['ct']
  },
  {
    value: 994340,
    label:
      'Connecticut Light and Power (Electric) - Heating and Cooling Rebate Program',
    states: ['ct']
  },
  {
    value: 992654,
    label: 'Mass Energy - Renewable Energy Certificate Incentive',
    states: ['ct']
  },
  {
    value: 9916396,
    label: 'United Illuminating Company - Business Energy Solutions',
    states: ['ct']
  },
  {
    value: 994338,
    label: '(Electric and Gas ) Home Energy Solutions Rebate Program',
    states: ['ct']
  },
  {
    value: 993941,
    label: '(Gas) Commercial and Industrial Gas Rebate Program',
    states: ['ct']
  },
  {
    value: 993940,
    label: 'Yankeegas -  Cooking and Water Heating Rebate Program',
    states: ['ct']
  },
  {
    value: 993938,
    label: 'Connecticut Natural Gas - Cooking and Water Heating Rebate Program',
    states: ['ct']
  },
  {
    value: 993934,
    label:
      'Southern Connecticut Gas - Custom Commercial Energy Efficiency Program',
    states: ['ct']
  },
  {
    value: 993933,
    label: 'Yankee Gas - Custom Commercial Energy Efficiency Program',
    states: ['ct']
  },
  {
    value: 993930,
    label:
      'Connecticut Natural Gas - Custom Commercial Energy Efficiency Program',
    states: ['ct']
  },
  {
    value: 993889,
    label:
      'The United Illuminating Company - Residential New Construction Program',
    states: ['ct']
  },
  {
    value: 99196,
    label: 'Energy Conservation Loan',
    states: ['ct']
  },
  {
    value: 993888,
    label: 'Connecticut Light & Power - Residential New Construction Program',
    states: ['ct']
  },
  {
    value: 993887,
    label:
      'Connecticut Light & Power - Energy Conscious Blueprint Rebate Program',
    states: ['ct']
  },
  {
    value: 993844,
    label: 'Connecticut - Residential Energy-Efficient Appliance Rebates',
    states: ['ct']
  },
  {
    value: 99197,
    label: 'Alternative Fuel Vehicles and Associated Equipment',
    states: ['ct']
  },
  {
    value: 993802,
    label: 'Geothermal Rebate Program',
    states: ['ct']
  },
  {
    value: 9916390,
    label: 'Commercial Conservation Programs',
    states: ['ct']
  },
  {
    value: 993730,
    label: 'Solar Thermal Incentive Program',
    states: ['ct']
  },
  {
    value: 9916290,
    label: 'ISO New England - Demand Resources',
    states: ['ct']
  },
  {
    value: 993706,
    label: 'New Generation Energy - Community Solar Lending Program',
    states: ['ct']
  },
  {
    value: 993705,
    label:
      'New Generation Energy - Community Food Service Efficiency Lending Program',
    states: ['ct']
  },
  {
    value: 993447,
    label:
      'Energy Efficiency Fund (Electric) - Residential Heating and Cooling Rebates',
    states: ['ct']
  },
  {
    value: 993445,
    label: 'CL&P - Residential Heating and Cooling Rebates',
    states: ['ct']
  },
  {
    value: 993373,
    label: 'Commercial and Industrial Rebate Program',
    states: ['ct']
  },
  {
    value: 993003,
    label: 'CCEF - Affordable Housing Initiative Solar PV Rebate Program',
    states: ['ct']
  },
  {
    value: 993081,
    label: 'CT Solar Lease',
    states: ['ct']
  },
  {
    value: 993141,
    label: 'Furnace and Boiler Replacement Rebate Program',
    states: ['ct']
  },
  {
    value: 993115,
    label: 'Norwich Public Utilities - Zero Percent Financing Program',
    states: ['ct']
  },
  {
    value: 993111,
    label:
      'Norwich Public Utilities - Commercial Energy Efficiency Rebate Program',
    states: ['ct']
  },
  {
    value: 993112,
    label:
      'Norwich Public Utilities (Electric) - Residential Energy Efficiency Rebate Program',
    states: ['ct']
  },
  {
    value: 99129,
    label: 'Alternative Fueled Vehicle Charging Station Credit',
    states: ['ct']
  },
  {
    value: 99239,
    label: 'Fuel Mix and Emissions Disclosure',
    states: ['ct']
  },
  {
    value: 9916288,
    label:
      'U.S. Department of Energy Industrial Assessment Center (IAC): University of Massachusetts',
    states: ['ct']
  },
  {
    value: 99240,
    label: 'Property Tax Exemption for Renewable Energy Systems',
    states: ['ct']
  },
  {
    value: 991046,
    label: 'New Energy Technology Program',
    states: ['ct']
  },
  {
    value: 991059,
    label: 'Interconnection Standards',
    states: ['ct']
  },
  {
    value: 9922037,
    label: 'Local Option - Commercial PACE Financing',
    states: ['ma']
  },
  {
    value: 9933,
    label: 'Green Power Predevelopment Financing Grant',
    states: ['ma']
  },
  {
    value: 99147,
    label: 'Excise Tax Exemption for Solar or Wind Powered Systems',
    states: ['ma']
  },
  {
    value: 995367,
    label: 'Commonwealth Outdoor Hydronic Heater Change-Out Pilot Program',
    states: ['ma']
  },
  {
    value: 99141,
    label: 'Clustered PV Installation Program',
    states: ['ma']
  },
  {
    value: 99144,
    label: 'Residential Renewable Energy Income Tax Credit',
    states: ['ma']
  },
  {
    value: 99145,
    label: 'Renewable Energy Equipment Sales Tax Exemption',
    states: ['ma']
  },
  {
    value: 99146,
    label: 'Renewable Energy Property Tax Exemption',
    states: ['ma']
  },
  {
    value: 99148,
    label: 'Excise Tax Deduction for Solar or Wind Powered Systems',
    states: ['ma']
  },
  {
    value: 99149,
    label:
      'Alternative Energy and Energy Conservation Patent Income Tax Deduction (Corporate)',
    states: ['ma']
  },
  {
    value: 99177,
    label:
      'Mass Energy Consumers Alliance - Renewable Energy Certificate Incentive',
    states: ['ma']
  },
  {
    value: 99229,
    label:
      'Alternative Energy and Energy Conservation Patent Income Tax Deduction (Personal)',
    states: ['ma']
  },
  {
    value: 99281,
    label: 'Net Metering',
    states: ['ma']
  },
  {
    value: 99298,
    label: 'MTC - Renewable Energy Credit Payment Options',
    states: ['ma']
  },
  {
    value: 99301,
    label: 'Solar Easements & Rights Laws',
    states: ['ma']
  },
  {
    value: 99307,
    label: "Cape Cod & Martha's Vineyard - Green Power Purchasing",
    states: ['ma']
  },
  {
    value: 99349,
    label: 'Medford Solar Program',
    states: ['ma']
  },
  {
    value: 99332,
    label: 'MTC - Matching Grants for Communities',
    states: ['ma']
  },
  {
    value: 99345,
    label: 'Commonwealth Wind Incentive Program - Micro Wind Initiative',
    states: ['ma']
  },
  {
    value: 99479,
    label: 'Renewable Portfolio Standard',
    states: ['ma']
  },
  {
    value: 99480,
    label: 'Fuel Mix and Emissions Disclosure',
    states: ['ma']
  },
  {
    value: 99543,
    label: 'Open PV Installation Program',
    states: ['ma']
  },
  {
    value: 99580,
    label:
      'Cape & Islands Self-Reliance Corporation - Home Energy Loan Program',
    states: ['ma']
  },
  {
    value: 99732,
    label: 'Renewable Energy Trust Fund',
    states: ['ma']
  },
  {
    value: 99849,
    label: 'Green Schools Initiative',
    states: ['ma']
  },
  {
    value: 99850,
    label: 'Green Buildings Initiative',
    states: ['ma']
  },
  {
    value: 99875,
    label: 'Newton - Solar Hot Water System Rebate',
    states: ['ma']
  },
  {
    value: 99930,
    label: 'Green Power Purchasing',
    states: ['ma']
  },
  {
    value: 99940,
    label: 'Fuel Cell Grants',
    states: ['ma']
  },
  {
    value: 99986,
    label: 'Interconnection Standards',
    states: ['ma']
  },
  {
    value: 991076,
    label: 'MTC - Large Onsite Renewables Initiative (LORI) Grants',
    states: ['ma']
  },
  {
    value: 991146,
    label: 'Energy Conservation Improvement Program',
    states: ['ma']
  },
  {
    value: 991269,
    label:
      'MassCEC - Sustainable Energy Economic Development (SEED) Initiative',
    states: ['ma']
  },
  {
    value: 991284,
    label: 'Residential Solar and Efficiency Tax Credit - Personal',
    states: ['ma']
  },
  {
    value: 991285,
    label: 'Residential Solar and Efficiency Tax Credit - Corporate',
    states: ['ma']
  },
  {
    value: 991303,
    label:
      'National Grid - Residential (Gas) Solar Water Heating Rebate Program',
    states: ['ma']
  },
  {
    value: 991334,
    label: 'Berkshire Gas - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991337,
    label:
      'Holyoke Gas & Electric - Residential Energy Conservation Loan Program',
    states: ['ma']
  },
  {
    value: 991338,
    label:
      'Holyoke Gas & Electric - Commercial Energy Conservation Loan Program',
    states: ['ma']
  },
  {
    value: 991339,
    label:
      'National Grid (Electric) - Residential Energy Efficiency Incentive Programs',
    states: ['ma']
  },
  {
    value: 991342,
    label:
      'Wakefield Municipal Gas & Light Department - Residential Conservation Services Program',
    states: ['ma']
  },
  {
    value: 991353,
    label:
      'National Grid (Mass Electric) - Small Business Energy Efficiency Program',
    states: ['ma']
  },
  {
    value: 991355,
    label:
      'New England Gas Company - Residential and Commercial Energy Efficiency Rebate Programs',
    states: ['ma']
  },
  {
    value: 991375,
    label: 'Unitil - Residential Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 991379,
    label: 'Unitil (Gas) - Business Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 991380,
    label:
      'Columbia Gas of Massachusetts - Residential Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 991381,
    label:
      'Columbia Gas of Massachusetts - Commercial Energy Efficiency Program',
    states: ['ma']
  },
  {
    value: 991383,
    label:
      'National Grid (Electric) - Commercial Energy Efficiency Incentive Programs',
    states: ['ma']
  },
  {
    value: 991389,
    label:
      'National Grid - Small/Mid-Sized Business Energy Efficiency Loan/Rebate Program',
    states: ['ma']
  },
  {
    value: 991390,
    label:
      'National Grid (Nantucket) - Commercial Energy Efficiency Incentive Programs',
    states: ['ma']
  },
  {
    value: 991391,
    label:
      'National Grid (Nantucket) - Residential Energy Efficiency Incentive Programs',
    states: ['ma']
  },
  {
    value: 991395,
    label: 'NSTAR (Gas) - Residential Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 991396,
    label: 'NSTAR (Electric) - Construction Solutions Program',
    states: ['ma']
  },
  {
    value: 991397,
    label: 'NSTAR (Electric) - Business Solutions Program',
    states: ['ma']
  },
  {
    value: 991400,
    label: 'National Grid - Commercial Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 991402,
    label: 'National Grid (Gas) - Residential Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 991403,
    label:
      'National Grid Energy Delivery - Building Practices and Demonstration Program',
    states: ['ma']
  },
  {
    value: 991567,
    label: 'Appliance Efficiency Standards',
    states: ['ma']
  },
  {
    value: 991598,
    label: 'Corporate Tax Credit for Solar Water Heating Systems',
    states: ['ma']
  },
  {
    value: 9918330,
    label: 'Reading Municipal Light Department - Commercial Customers',
    states: ['ma']
  },
  {
    value: 991675,
    label: 'MTC - Clean Energy Pre-Development Financing Initiative (Grants)',
    states: ['ma']
  },
  {
    value: 991685,
    label: 'MTC - Clean Energy Pre-Development Financing Initiative (Loans)',
    states: ['ma']
  },
  {
    value: 991802,
    label:
      'Belmont Municipal Light Department - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991817,
    label:
      'North Attleborough Electric Department - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991806,
    label:
      'Chicopee Electric Light Department - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991807,
    label:
      'Concord Municipal Light Plant - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991808,
    label:
      'Concord Municipal Light Plant - Commercial Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991811,
    label:
      'Mansfield Municipal Electric Department - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991812,
    label:
      'Marblehead Municipal Light Department - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 991828,
    label:
      'North Attleborough Electric Department - Power Saver Rebate Program',
    states: ['ma']
  },
  {
    value: 991829,
    label:
      'Reading Municipal Light Department - Residential Energy Star Appliance Rebate Program',
    states: ['ma']
  },
  {
    value: 991831,
    label:
      'Reading Municipal Light Department - Commercial Lighting Retrofit Program',
    states: ['ma']
  },
  {
    value: 991871,
    label: 'Building Energy Code',
    states: ['ma']
  },
  {
    value: 991929,
    label: 'Shrewsbury Electric - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 992107,
    label: 'Mass Save - HEAT Loan Program',
    states: ['ma']
  },
  {
    value: 992257,
    label: 'Energy Efficiency Fund',
    states: ['ma']
  },
  {
    value: 992504,
    label: 'City of Boston - Green Power Purchasing',
    states: ['ma']
  },
  {
    value: 992529,
    label: 'MTC - Massachusetts Green Communities Grant',
    states: ['ma']
  },
  {
    value: 992535,
    label: 'MTC - Massachusetts Green Communities Loan',
    states: ['ma']
  },
  {
    value: 992536,
    label: 'Boston Community Capital - Energy Advantage Program',
    states: ['ma']
  },
  {
    value: 992598,
    label: 'MTC - Business Expansion Initiative',
    states: ['ma']
  },
  {
    value: 992569,
    label: 'Energy Reduction Plan for State Buildings',
    states: ['ma']
  },
  {
    value: 993324,
    label: 'NSTAR (Electric) - Small Business Direct Install Program',
    states: ['ma']
  },
  {
    value: 992782,
    label:
      'Model As-of Right Zoning Ordinance or Bylaw: Allowing Use of Wind Energy Facilities',
    states: ['ma']
  },
  {
    value: 992851,
    label: 'Commonwealth Solar II Rebates',
    states: ['ma']
  },
  {
    value: 992886,
    label: 'Chicopee Electric Light - Residential Solar Rebate Program',
    states: ['ma']
  },
  {
    value: 993000,
    label: 'Green Power Purchasing Commitment',
    states: ['ma']
  },
  {
    value: 9917470,
    label:
      'Massachusetts Division of Energy Resources - Green Business Development',
    states: ['ma']
  },
  {
    value: 993017,
    label: 'National Grid (Gas)â€“ Commercial Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 993126,
    label: 'Model Ordinance for Permitting of Small Wind Facilities',
    states: ['ma']
  },
  {
    value: 993217,
    label: 'MuniHELPS - Offered by 17 Utilities through the MMWEC',
    states: ['ma']
  },
  {
    value: 993338,
    label: 'Eversource (Gas) - Commercial Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 993377,
    label:
      'Western Massachusetts Electric - Commercial Energy Efficiency Rebates',
    states: ['ma']
  },
  {
    value: 993378,
    label:
      'National Grid (Electric) - Small Business Energy Efficiency Loan/Rebate Program',
    states: ['ma']
  },
  {
    value: 993379,
    label: 'WMECO -  New Construction/Major Renovations Program',
    states: ['ma']
  },
  {
    value: 993435,
    label: 'Commonwealth Wind Community-Scale Initiative',
    states: ['ma']
  },
  {
    value: 993456,
    label: 'Marblehead Municipal Light Department - Solar Rebate Program',
    states: ['ma']
  },
  {
    value: 993487,
    label: 'Cape Light Compact - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 993488,
    label: 'Cape Light Compact - Commercial Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 993628,
    label: 'National Grid (Gas) - Commercial Solar Thermal Rebate Program',
    states: ['ma']
  },
  {
    value: 993657,
    label: 'Commonwealth Wind Program',
    states: ['ma']
  },
  {
    value: 993658,
    label:
      'MassCEC - Commonwealth Wind Incentive Program - Commercial Wind Initiative Loan',
    states: ['ma']
  },
  {
    value: 993677,
    label: 'Commonwealth Hydropower Program',
    states: ['ma']
  },
  {
    value: 993701,
    label: 'New Generation Energy - Community Solar Lending Program',
    states: ['ma']
  },
  {
    value: 993728,
    label: 'Concord Municipal Light Plant - Solar Photovoltaic Rebate Program',
    states: ['ma']
  },
  {
    value: 993783,
    label:
      'New Generation Energy - Community Food Service Efficiency Lending Program',
    states: ['ma']
  },
  {
    value: 993862,
    label: 'Massachusetts - Residential Energy-Efficient Appliance Rebates',
    states: ['ma']
  },
  {
    value: 993942,
    label: 'MassCEC - Commonwealth Solar Stimulus',
    states: ['ma']
  },
  {
    value: 993991,
    label: 'Solar Renewable Energy Certificates (SREC-I)',
    states: ['ma']
  },
  {
    value: 994037,
    label: 'Residential New Construction Program',
    states: ['ma']
  },
  {
    value: 994055,
    label: 'Major Renovations Program',
    states: ['ma']
  },
  {
    value: 994061,
    label:
      'Model As-of Right Zoning Ordinance or Bylaw: Allowing Use of Large-Scale Solar Energy Facilities',
    states: ['ma']
  },
  {
    value: 994067,
    label: 'Green Communities Grant Program',
    states: ['ma']
  },
  {
    value: 994214,
    label: 'Unitil - Commercial and Industrial Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 994259,
    label: 'Berkshire Gas - Commercial Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 994263,
    label:
      'Western Massachusetts Electric - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 9918953,
    label:
      'Rowley Municipal Lighting Plant - Commercial Energy Audits and Rebates',
    states: ['ma']
  },
  {
    value: 994282,
    label: 'Taunton Municipal Lighting Plant - Residential PV Rebate Program',
    states: ['ma']
  },
  {
    value: 994283,
    label: 'Local Option - Energy Revolving Loan Fund',
    states: ['ma']
  },
  {
    value: 994298,
    label: 'NSTAR (Electric) - Residential Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 994378,
    label:
      'MMWEC Green Opportunity Commercial and Industrial Efficiency Program',
    states: ['ma']
  },
  {
    value: 994379,
    label: 'Ipswich Utilities - HELPS PV Solar Rebate',
    states: ['ma']
  },
  {
    value: 994431,
    label: 'City of Boston - Renew Boston Residential Retrofit Program',
    states: ['ma']
  },
  {
    value: 994500,
    label: 'Energy Efficiency First Fuel Requirement (Gas and Electric)',
    states: ['ma']
  },
  {
    value: 994557,
    label: 'Commonwealth Residential & Small-Scale Solar Hot Water Program',
    states: ['ma']
  },
  {
    value: 994561,
    label:
      'Taunton Municipal Lighting Plant - Residential Energy Star Appliance Rebate Program',
    states: ['ma']
  },
  {
    value: 994595,
    label:
      'Reading Municipal Light Department - Business Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 994605,
    label:
      'Reading Municipal Light Department - Residential Renewable Energy Rebates',
    states: ['ma']
  },
  {
    value: 994624,
    label: 'Alternative Energy Portfolio Standard',
    states: ['ma']
  },
  {
    value: 994791,
    label:
      'MassSAVE (Electric) - Commercial New Construction/Major Renovation Program',
    states: ['ma']
  },
  {
    value: 994794,
    label: 'Gas Networks - Commercial Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 994797,
    label: 'Mass Save (Gas) - Residential Rebate Program',
    states: ['ma']
  },
  {
    value: 994798,
    label: 'Mass Save (Electric) - Large Commercial Retrofit Program',
    states: ['ma']
  },
  {
    value: 994799,
    label: 'Mass Save (Electric) - Residential Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 994807,
    label:
      'Wellesley Municipal Light Plant - Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 994918,
    label: 'City of Boston - Renew Boston Solar Program',
    states: ['ma']
  },
  {
    value: 994962,
    label: 'Commercial Solar Hot Water Rebate Program',
    states: ['ma']
  },
  {
    value: 995038,
    label: 'Mass Save - Financing for Business Program',
    states: ['ma']
  },
  {
    value: 995039,
    label: 'Commonwealth Organics-to-Energy Program',
    states: ['ma']
  },
  {
    value: 995070,
    label: 'ReBuild Western Massachusetts Grant Program',
    states: ['ma']
  },
  {
    value: 995071,
    label: 'ReBuild Western Massachusetts Loan Program',
    states: ['ma']
  },
  {
    value: 995157,
    label:
      'City of Cambridge - Cambridge Energy Alliance Solar Hot Water Grant',
    states: ['ma']
  },
  {
    value: 995189,
    label: 'Hudson Light & Power - Photovoltaic Incentive Program',
    states: ['ma']
  },
  {
    value: 995239,
    label:
      'Chicopee Electric Light - Commercial Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 995289,
    label: 'City of Lowell - BLEU Projects Program',
    states: ['ma']
  },
  {
    value: 995319,
    label:
      'Taunton Municipal Lighting Plant - Residential and Non-Profit Weatherization Program',
    states: ['ma']
  },
  {
    value: 995357,
    label: 'Commonwealth Woodstove Change-Out Program',
    states: ['ma']
  },
  {
    value: 995359,
    label: 'Commercial Solar Hot Water Financing Program',
    states: ['ma']
  },
  {
    value: 995380,
    label: 'Commonwealth Small Pellet Boiler Grant Program',
    states: ['ma']
  },
  {
    value: 9913957,
    label: 'National Grid - Existing Facility Incentives',
    states: ['ma']
  },
  {
    value: 995515,
    label: 'Solar Renewable Energy Certificates (SREC-II)',
    states: ['ma']
  },
  {
    value: 995635,
    label: 'Residential & Small-Scale Air-Source Heat Pump Program',
    states: ['ma']
  },
  {
    value: 995636,
    label: 'Residential & Small-Scale Ground-Source Heat Pump Program',
    states: ['ma']
  },
  {
    value: 995644,
    label: 'Residential & Small-Scale Biomass Heating Program',
    states: ['ma']
  },
  {
    value: 995678,
    label: 'Solar Renewable Energy Certificates (SREC-I)',
    states: ['ma']
  },
  {
    value: 995679,
    label: 'Solar Renewable Energy Certificates (SREC-II)',
    states: ['ma']
  },
  {
    value: 995782,
    label: 'Cape Light Compact- Residential Energy Efficiency Rebate Program',
    states: ['ma']
  },
  {
    value: 995808,
    label: 'Leading By Example Solar Photovoltaic Canopy Grant Program',
    states: ['ma']
  },
  {
    value: 995828,
    label: 'Mass Save (Electric) - Small Business Direct Install Program',
    states: ['ma']
  },
  {
    value: 995850,
    label: 'Mass Solar Loan Program',
    states: ['ma']
  },
  {
    value: 995919,
    label: 'City of Boston - Green Building Standard',
    states: ['ma']
  },
  {
    value: 9913956,
    label: 'Mass Save - New Construction/Major Renovations Program',
    states: ['ma']
  },
  {
    value: 9913947,
    label:
      'Columbia Gas of Massachusetts - Medium and Large Business Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 9913952,
    label: 'Concord Municipal Light Plant - Energy Resources For Businesses',
    states: ['ma']
  },
  {
    value: 9913955,
    label: 'National Grid - Building Operator Certification Program',
    states: ['ma']
  },
  {
    value: 9914062,
    label: 'National Grid - Building Practices & Demonstration Program',
    states: ['ma']
  },
  {
    value: 9914078,
    label: 'National Grid - Energy Profiler Online',
    states: ['ma']
  },
  {
    value: 9916193,
    label: 'Holyoke Gas & Electric - Commercial Energy Audits',
    states: ['ma']
  },
  {
    value: 9916282,
    label:
      'Massachusetts Executive Office of Energy and Environmental Affairs - Energy Efficiency Assistance for Business',
    states: ['ma']
  },
  {
    value: 9916286,
    label:
      'Massachusetts Office of Technical Assistance and Technology - OTA Software Programs',
    states: ['ma']
  },
  {
    value: 9916287,
    label:
      'Massachusetts Office of Technical Assistance and Technology - OTA Energy Publications',
    states: ['ma']
  },
  {
    value: 9916289,
    label:
      'U.S. Department of Energy - Massachusetts Energy Efficiency Partnership',
    states: ['ma']
  },
  {
    value: 9917454,
    label: 'National Grid - Financing Solutions For Natural Gas Equipment',
    states: ['ma']
  },
  {
    value: 9917458,
    label: 'National Grid - Power Quality Enhancements Program',
    states: ['ma']
  },
  {
    value: 9917478,
    label:
      'Berkshire Gas - GasNetworks Commercial & Industrial High Efficiency Heating Rebate Program',
    states: ['ma']
  },
  {
    value: 9917480,
    label: 'National Grid - Demand Response',
    states: ['ma']
  },
  {
    value: 9917481,
    label: 'National Grid - Enhanced Metering',
    states: ['ma']
  },
  {
    value: 9917573,
    label:
      'Massachusetts Division of Energy Resources - Education and Outreach Programs for Businesses',
    states: ['ma']
  },
  {
    value: 9917574,
    label:
      'Massachusetts Division of Energy Resources - Municipal Energy Efficiency',
    states: ['ma']
  },
  {
    value: 9917578,
    label:
      'Western Massachusetts Electric - Massachusetts Energy Efficiency Partnership',
    states: ['ma']
  },
  {
    value: 9917727,
    label:
      'Massachusetts Office of Technical Assistance and Technology - Energy Efficiency for Businesses & Institutions',
    states: ['ma']
  },
  {
    value: 9918962,
    label: 'Hudson Light & Power - Commercial and Industrial Energy Audits',
    states: ['ma']
  },
  {
    value: 9919774,
    label: 'Western Massachusetts Electric - Power Purchase',
    states: ['ma']
  },
  {
    value: 9919888,
    label:
      'Westfield Gas & Electric Light Dept. - Commercial & Industrial New Construction and Lost Opportunity Pilot Program',
    states: ['ma']
  },
  {
    value: 9919911,
    label:
      'Ipswich Municipal Light - Commercial & Industrial Energy Efficiency Programs',
    states: ['ma']
  },
  {
    value: 9919913,
    label:
      'Ipswich Municipal Light - Commercial & Industrial New Construction and Major Renovation Pilot Program',
    states: ['ma']
  },
  {
    value: 9919914,
    label:
      'Ipswich Municipal Light - Commercial & Industrial Renewable Energy and Demand Response Options',
    states: ['ma']
  },
  {
    value: 9920099,
    label:
      'Massachusetts Division of Energy Resources - Assessments and Audits',
    states: ['ma']
  },
  {
    value: 9920123,
    label:
      'Columbia Gas of Massachusetts - Small Business Energy Efficiency Program',
    states: ['ma']
  },
  {
    value: 9920258,
    label: 'Chicopee Electric Light - Custom Retrofit GO Program',
    states: ['ma']
  },
  {
    value: 9920625,
    label: 'Taunton Municipal Lighting Plant - Net Metering',
    states: ['ma']
  },
  {
    value: 9921157,
    label: 'National Grid - Massachusetts Energy Efficiency Services',
    states: ['ma']
  },
  {
    value: 9921171,
    label: 'National Grid - Rhode Island Energy Efficiency Services',
    states: ['ma']
  },
  {
    value: 9921186,
    label: 'Mass Save - Small Business Program',
    states: ['ma']
  },
  {
    value: 9921187,
    label: 'National Grid - Construction Program',
    states: ['ma']
  },
  {
    value: 9921571,
    label: 'Unitil - Energy Saving Tips',
    states: ['ma']
  },
  {
    value: 9921671,
    label: 'ISO New England - Demand Resources',
    states: ['ma']
  },
  {
    value: 9921674,
    label:
      'Northeast Energy Efficiency Council - Building Operator Certification (BOC)',
    states: ['ma']
  },
  {
    value: 9922020,
    label: 'Northeast Energy Efficiency Partnerships - EM&V Forum',
    states: ['ma']
  },
  {
    value: 9922036,
    label: 'Commercial Biomass Heating Grant Program',
    states: ['ma']
  },
  {
    value: 9921635,
    label: 'FirstEnergy Solutions - Business Energy Analyzer',
    states: ['nj']
  },
  {
    value: 991477,
    label: 'ENERGY STAR Homes Program',
    states: ['nj']
  },
  {
    value: 995715,
    label: 'SREC-Based Financing Program',
    states: ['nj']
  },
  {
    value: 995716,
    label: 'SREC-Based Financing Program (ACE, JCP&L, RECO)',
    states: ['nj']
  },
  {
    value: 995717,
    label: 'SREC-Based Financing Program (ACE, JCP&L, RECO)',
    states: ['nj']
  },
  {
    value: 991465,
    label: 'South Jersey Gas - Residential Loan Program',
    states: ['nj']
  },
  {
    value: 995728,
    label:
      'New Jersey Natural Gas- SAVEGREEN Commercial On-Bill Financing Program',
    states: ['nj']
  },
  {
    value: 99898,
    label: 'New Jersey - Green Power Purchasing',
    states: ['nj']
  },
  {
    value: 992979,
    label:
      'New Jersey Natural Gas (NJNG) - Home Performance with Energy Star Rebate',
    states: ['nj']
  },
  {
    value: 995729,
    label: 'South Jersey Gas Commerical and Industrial Loan Program',
    states: ['nj']
  },
  {
    value: 991326,
    label: 'Combined Heat & Power (CHP) Program',
    states: ['nj']
  },
  {
    value: 993461,
    label: 'Clean Energy Solutions Capital Investment Loan/Grant Program',
    states: ['nj']
  },
  {
    value: 991249,
    label: 'Renewable Energy Business Venture Assistance Program (REBVAP)',
    states: ['nj']
  },
  {
    value: 99797,
    label: 'Interconnection Standards',
    states: ['nj']
  },
  {
    value: 991152,
    label: 'Sustainable Development Loan Fund',
    states: ['nj']
  },
  {
    value: 991151,
    label: 'NJ Clean Energy- WARMAdvantage Program (Electric and Gas)',
    states: ['nj']
  },
  {
    value: 994983,
    label: 'PSE&G - Multi-Family Residential Efficiency Program',
    states: ['nj']
  },
  {
    value: 9916416,
    label: 'New Jersey Natural Gas - Energy-Saving Tips for Your Business',
    states: ['nj']
  },
  {
    value: 991855,
    label: 'Building Energy Code',
    states: ['nj']
  },
  {
    value: 9916482,
    label: 'New Jersey Board of Public Utilities - Pay for Performance',
    states: ['nj']
  },
  {
    value: 9916483,
    label: 'New Jersey Board of Public Utilities - Renewable Energy Program',
    states: ['nj']
  },
  {
    value: 992722,
    label: 'Residential Solar Rights',
    states: ['nj']
  },
  {
    value: 995012,
    label: 'Orange and Rockland Utilities (Electric) - HVAC Efficiency Program',
    states: ['nj']
  },
  {
    value: 994805,
    label:
      'New Jersey Natural Gas - SAVEGREEN Residential On-Bill Financing Program',
    states: ['nj']
  },
  {
    value: 9921638,
    label: 'First Energy - Business Energy Analyzer',
    states: ['nj']
  },
  {
    value: 993671,
    label: 'Solar Domestic Hot Water Pilot Program',
    states: ['nj']
  },
  {
    value: 99595,
    label: 'Renewable Energy Advanced Power Program',
    states: ['nj']
  },
  {
    value: 993678,
    label: 'Edison Innovation Clean Energy Fund',
    states: ['nj']
  },
  {
    value: 99589,
    label:
      'New Jersey Renewable Energy Incentive Program (Sustainable Biopower)',
    states: ['nj']
  },
  {
    value: 991568,
    label: 'Energy Efficiency Product Standards',
    states: ['nj']
  },
  {
    value: 992910,
    label: 'PSE&G - Solar Loan Program',
    states: ['nj']
  },
  {
    value: 991150,
    label: 'COOLAdvantage Program',
    states: ['nj']
  },
  {
    value: 99565,
    label: 'Environmental Information Disclosure',
    states: ['nj']
  },
  {
    value: 992890,
    label: 'New Jersey Comfort Partners Program',
    states: ['nj']
  },
  {
    value: 991149,
    label: 'Clean Energy Financing for Businesses',
    states: ['nj']
  },
  {
    value: 993736,
    label: 'Grid-Connected Renewables Program',
    states: ['nj']
  },
  {
    value: 99219,
    label: 'Solar Energy Sales Tax Exemption',
    states: ['nj']
  },
  {
    value: 991148,
    label: 'Cogeneration Facility Sales Tax Exemption',
    states: ['nj']
  },
  {
    value: 993756,
    label: 'New Jersey Natural Gas - SAVEGREEN Residential Rebate Program',
    states: ['nj']
  },
  {
    value: 995205,
    label: 'Small Scale CHP and Fuel Cell Incentive Program',
    states: ['nj']
  },
  {
    value: 995811,
    label: 'NJ Clean Energy- Residential New Construction Program',
    states: ['nj']
  },
  {
    value: 99564,
    label: 'Renewables Portfolio Standard',
    states: ['nj']
  },
  {
    value: 994848,
    label: 'Edison Innovation Green Growth Fund Loans',
    states: ['nj']
  },
  {
    value: 9917594,
    label:
      'U.S. Department of Energy Industrial Assessment Center (IAC): Lehigh University',
    states: ['nj']
  },
  {
    value: 9921919,
    label:
      'New Jersey’s Clean Energy Program - Commercial Industrial and Local Government Programs',
    states: ['nj']
  },
  {
    value: 995873,
    label: 'New Jersey Energy Resilience Bank',
    states: ['nj']
  },
  {
    value: 9922023,
    label: 'Northeast Energy Efficiency Partnerships - EM&V Forum',
    states: ['nj']
  },
  {
    value: 995109,
    label: 'Local Option - Property Assessed Clean Energy Financing',
    states: ['nj']
  },
  {
    value: 995567,
    label: 'Local Energy Audit Program',
    states: ['nj']
  },
  {
    value: 995568,
    label: 'Large Energy Users Program',
    states: ['nj']
  },
  {
    value: 992359,
    label: 'New Jersey SmartStart Buildings - New Construction and Retrofits',
    states: ['nj']
  },
  {
    value: 992615,
    label: 'South Jersey Gas - Residential Energy Efficiency Rebate Program',
    states: ['nj']
  },
  {
    value: 9919788,
    label: 'New Jersey Board of Public Utilities - NJ Clean Energy Program',
    states: ['nj']
  },
  {
    value: 9938,
    label: 'Net Metering',
    states: ['nj']
  },
  {
    value: 9914025,
    label: 'New Jersey Board of Public Utilities - NJ SmartStart Buildings',
    states: ['nj']
  },
  {
    value: 9914029,
    label: 'Atlantic City Electric - Energy Profiler Online',
    states: ['nj']
  },
  {
    value: 99168,
    label: 'Societal Benefits Charge',
    states: ['nj']
  },
  {
    value: 9921541,
    label: 'FirstEnergy Solutions - Power Management Platform',
    states: ['nj']
  },
  {
    value: 993883,
    label:
      'Renewable Energy Manufacturing Incentives (for End-Use PV Installations)',
    states: ['nj']
  },
  {
    value: 994548,
    label: 'Utility Solar Financing Incentive (ACE, JCP&L, RECO)',
    states: ['nj']
  },
  {
    value: 994588,
    label: 'PSE&G - Commercial Efficiency Program',
    states: ['nj']
  },
  {
    value: 991110,
    label: 'Solar Renewable Energy Certificates (SRECs)',
    states: ['nj']
  },
  {
    value: 993907,
    label: 'PSE&G - Residential Efficiency Program',
    states: ['nj']
  },
  {
    value: 993929,
    label: 'Solar and Wind Permitting Laws',
    states: ['nj']
  },
  {
    value: 994933,
    label: 'Clean Energy Solutions Energy Efficiency Revolving Loan Fund',
    states: ['nj']
  },
  {
    value: 991054,
    label: 'Renewable Energy Economic Development Program (REED)',
    states: ['nj']
  },
  {
    value: 991053,
    label:
      'Clean Energy Financing for Local Schools and Governments (REDO Program)',
    states: ['nj']
  },
  {
    value: 993100,
    label: 'Property Tax Exemption for Renewable Energy Systems',
    states: ['nj']
  },
  {
    value: 9919,
    label: 'Solar Easements',
    states: ['nj']
  },
  {
    value: 9921920,
    label:
      'New Jersey Manufacturing Extension Program - Operational Excellence Program',
    states: ['nj']
  },
  {
    value: 9921921,
    label: 'New Jersey Board of Public Utilities - Commercial Customers',
    states: ['nj']
  },
  {
    value: 993966,
    label: 'New Jersey Direct Install Program',
    states: ['nj']
  },
  {
    value: 993031,
    label: 'NJ Clean Energy- ENERGY STAR Appliance Rebate program',
    states: ['nj']
  },
  {
    value: 993014,
    label: 'High Performance Building Standards in New State Construction',
    states: ['nj']
  },
  {
    value: 994023,
    label: 'Solar Energy Option Requirement for Residential Developments',
    states: ['nj']
  },
  {
    value: 994026,
    label: 'Assessment of Farmland Hosting Renewable Energy Systems',
    states: ['nj']
  },
  {
    value: 994034,
    label: 'New Jersey - Residential Energy Efficient Appliance Rebate Program',
    states: ['nj']
  },
  {
    value: 994335,
    label: 'Clean Energy Solutions ARRA CHP Program',
    states: ['nj']
  },
  {
    value: 994560,
    label: 'Utility Solar Financing Programs (ACE, JCP&L, RECO)',
    states: ['nj']
  },
  {
    value: 993266,
    label:
      'Edison Innovation Clean Energy Manufacturing Fund - Grants and Loans',
    states: ['nj']
  },
  {
    value: 994360,
    label: 'Wind Manufacturing Tax Credit',
    states: ['nj']
  },
  {
    value: 9919892,
    label: 'South Jersey Gas - Business Services',
    states: ['nj']
  },
  {
    value: 991906,
    label: 'High Performance Schools Policy',
    states: ['nj']
  },
  {
    value: 9920368,
    label: "New Jersey's Clean Energy Program - Pay for Performance",
    states: ['nj']
  },
  {
    value: 9920375,
    label: "New Jersey's Clean Energy Program - Energy Benchmarking",
    states: ['nj']
  },
  {
    value: 9919893,
    label: 'South Jersey Gas - Business Services נCommercial Accounts',
    states: ['nj']
  },
  {
    value: 993330,
    label: 'Pay for Performance Program',
    states: ['nj']
  },
  {
    value: 994982,
    label:
      'PSE&G - Government and Non-Profit Facility Direct Install Efficiency Program',
    states: ['nj']
  },
  {
    value: 991502,
    label: 'Home Performance with ENERGY STAR Program',
    states: ['nj']
  },
  {
    value: 992978,
    label: 'Home Performance with ENERGY STAR Program',
    states: ['nj']
  },
  {
    value: 995165,
    label: 'Clean Energy Solutions Large Scale CHP and Fuel Cells Program',
    states: ['nj']
  },
  {
    value: 995687,
    label: 'Solar Renewable Energy Certificates (SRECs) Registration Program',
    states: ['nj']
  },
  {
    value: 992014,
    label: 'Austin Energy - Small Business Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 995254,
    label:
      'Brownsville Public Utilities Board - Green Living Residential Rebate Program',
    states: ['tx']
  },
  {
    value: 995304,
    label: 'Texas Gas Service - Residential Solar Water Heating Rebate Program',
    states: ['tx']
  },
  {
    value: 992013,
    label: 'Austin Energy - Commercial Energy Management Rebate Program',
    states: ['tx']
  },
  {
    value: 992012,
    label: 'Austin Energy - Residential Energy Efficiency Loan Program',
    states: ['tx']
  },
  {
    value: 9921808,
    label: 'Xcel Energy - Energy At Risk Financial Analysis Tool',
    states: ['tx']
  },
  {
    value: 992011,
    label: 'Austin Energy - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 995352,
    label: 'TXU - Commercial Energy Efficiency Program',
    states: ['tx']
  },
  {
    value: 992021,
    label: 'Bryan Texas Utilities - Low-Interest Insulation Loan Program',
    states: ['tx']
  },
  {
    value: 9921810,
    label: 'Xcel Energy - Energy Management Systems',
    states: ['tx']
  },
  {
    value: 991900,
    label: 'Building Energy Code',
    states: ['tx']
  },
  {
    value: 995411,
    label: 'Bryan Texas Utilities - SmartHOME Program',
    states: ['tx']
  },
  {
    value: 991594,
    label: 'Xcel Energy - Air Conditioner Distributor Program',
    states: ['tx']
  },
  {
    value: 995447,
    label: 'Austin Energy - Value of Solar Residential Rate',
    states: ['tx']
  },
  {
    value: 991593,
    label: 'Xcel Energy - Residential and Hard-to-Reach Standard Offer Program',
    states: ['tx']
  },
  {
    value: 991592,
    label: 'Xcel Energy - Commercial and Industrial Standard Offer Program',
    states: ['tx']
  },
  {
    value: 991548,
    label:
      'Texas-New Mexico Power Company - Energy Star Homes Market Transformation Program',
    states: ['tx']
  },
  {
    value: 995490,
    label: 'Entergy Texas - Home Performance with ENERGY STAR',
    states: ['tx']
  },
  {
    value: 9921817,
    label: 'Atmos Energy - Business Savings',
    states: ['tx']
  },
  {
    value: 995545,
    label: 'El Paso Electric Company - Net Metering',
    states: ['tx']
  },
  {
    value: 995547,
    label: 'San Antonio City Public Service (CPS Energy) - Net Metering',
    states: ['tx']
  },
  {
    value: 995570,
    label: 'City of Denton - Green Power Purchasing',
    states: ['tx']
  },
  {
    value: 995592,
    label:
      'City of Forth Worth - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 995590,
    label:
      'City of Fort Worth - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 995593,
    label:
      'City of Houston - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 995594,
    label: 'City of El Paso - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 995595,
    label:
      'City of El Paso - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 991544,
    label:
      'Texas-New Mexico Power Company - SCORE/CitySmart, Commercial Solutions, and Small Business Programs',
    states: ['tx']
  },
  {
    value: 991543,
    label:
      'Texas-New Mexico Power Company - Residential, Hard-to-Reach, and High-Performance New Homes Programs',
    states: ['tx']
  },
  {
    value: 991542,
    label:
      'Texas Gas Service - Commercial Water Heating Energy Efficiency Program',
    states: ['tx']
  },
  {
    value: 991540,
    label: 'Texas Gas Service - Food Service Equipment Program',
    states: ['tx']
  },
  {
    value: 9921955,
    label: 'El Paso Electric Company - Tools, Tips, and Calculators',
    states: ['tx']
  },
  {
    value: 995669,
    label: 'Austin Energy - Value of Solar Residential Rate',
    states: ['tx']
  },
  {
    value: 991536,
    label: 'Texas Gas Service - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 991538,
    label: 'Texas Gas Service - Commercial Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 991485,
    label: 'American Electric Power - Standard Offer Demand Response Program',
    states: ['tx']
  },
  {
    value: 995741,
    label: 'CenterPoint Energy Healthcare Energy Efficiency Program',
    states: ['tx']
  },
  {
    value: 995742,
    label: 'CenterPoint Energy Sustainable Schools Program',
    states: ['tx']
  },
  {
    value: 995743,
    label: 'CenterPoint Energy New Homes Program',
    states: ['tx']
  },
  {
    value: 995744,
    label: 'CenterPoint Energy Advanced Residential Lighting Program',
    states: ['tx']
  },
  {
    value: 995745,
    label: 'CenterPoint Energy A/C Distributor Program',
    states: ['tx']
  },
  {
    value: 995746,
    label: "CenterPoint Energy's Energy Wise Program",
    states: ['tx']
  },
  {
    value: 995748,
    label: 'CenterPoint Energy Low-Rise Multi Family Program',
    states: ['tx']
  },
  {
    value: 99182,
    label: 'Renewable Generation Requirement',
    states: ['tx']
  },
  {
    value: 9921956,
    label: 'El Paso Electric Company - Energy Library',
    states: ['tx']
  },
  {
    value: 99173,
    label: 'Renewable Energy Systems Property Tax Exemption',
    states: ['tx']
  },
  {
    value: 995858,
    label: 'Garland Power & Light - Solar Rebate Program',
    states: ['tx']
  },
  {
    value: 995893,
    label: 'City of San Antonio - Sec. 35-398. - Renewable Energy Systems',
    states: ['tx']
  },
  {
    value: 9921101,
    label: 'Pedernales Electric Cooperative - My Use Energy Analyzer',
    states: ['tx']
  },
  {
    value: 9982,
    label: 'Solar and Wind Energy Business Franchise Tax Exemption',
    states: ['tx']
  },
  {
    value: 995944,
    label: 'City of San Antonio - Energy Conservation Code',
    states: ['tx']
  },
  {
    value: 991134,
    label: 'LoanSTAR Revolving Loan Program',
    states: ['tx']
  },
  {
    value: 9981,
    label: 'Solar and Wind Energy Device Franchise Tax Deduction',
    states: ['tx']
  },
  {
    value: 9961,
    label: 'San Antonio City Public Service - Distributed Generation Program',
    states: ['tx']
  },
  {
    value: 9915761,
    label: 'Austin Energy - Load Profiler',
    states: ['tx']
  },
  {
    value: 9915763,
    label: 'Austin Energy - Energy Conservation Audit and Disclosure Ordinance',
    states: ['tx']
  },
  {
    value: 991088,
    label: 'Austin Energy - Residential Solar PV Rebate Program',
    states: ['tx']
  },
  {
    value: 9921567,
    label: 'El Paso Electric - Energy Library',
    states: ['tx']
  },
  {
    value: 993082,
    label: 'Oncor Electric Delivery - Commercial and Industrial Rebate Program',
    states: ['tx']
  },
  {
    value: 993168,
    label:
      'Oncor Electric Delivery - Solar Photovoltaic Standard Offer Program',
    states: ['tx']
  },
  {
    value: 993006,
    label: 'Plano - Renewable Energy Purchasing Policy',
    states: ['tx']
  },
  {
    value: 9915,
    label: 'Fuel Mix and Emissions Disclosure',
    states: ['tx']
  },
  {
    value: 993004,
    label: 'City of Plano - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 992988,
    label:
      'Oncor Electric Delivery - Data Center Energy Management Pilot Program',
    states: ['tx']
  },
  {
    value: 993285,
    label: 'Garland Power & Light - Energy Efficiency Rebate Programs',
    states: ['tx']
  },
  {
    value: 993298,
    label: 'Oncor Electric Delivery - Solar Water Heating Incentive Program',
    states: ['tx']
  },
  {
    value: 993313,
    label: 'Guadalupe Valley Electric Cooperative - Renewable Energy Rebates',
    states: ['tx']
  },
  {
    value: 993322,
    label:
      'Guadalupe Valley Electric Cooperative - Residential Energy Efficiency Rebate Programs',
    states: ['tx']
  },
  {
    value: 9921624,
    label: 'El Paso Electric - Tools, Tips, and Calculators',
    states: ['tx']
  },
  {
    value: 993346,
    label: 'Entergy Texas - Home Performance with ENERGY STAR Program',
    states: ['tx']
  },
  {
    value: 9921628,
    label: 'El Paso Electric Company - Large Commercial Solutions Program',
    states: ['tx']
  },
  {
    value: 99981,
    label: 'Ethanol and Biodiesel Production Incentive',
    states: ['tx']
  },
  {
    value: 993400,
    label: 'Green Mountain Energy Renewable Rewards Buy-Back Program',
    states: ['tx']
  },
  {
    value: 993419,
    label: 'Texas New Mexico Power Company - Solar PV Pilot Program',
    states: ['tx']
  },
  {
    value: 993429,
    label: 'Entergy Texas - Solar PV Pilot Program',
    states: ['tx']
  },
  {
    value: 993430,
    label:
      'Denton Municipal Electric - Commercial Standard Offer Rebate Program',
    states: ['tx']
  },
  {
    value: 993432,
    label:
      'Pedernales Electric Cooperative - Commercial  Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 992947,
    label: 'Bryan Texas Utilities - Solar Hot Water Rebate Program',
    states: ['tx']
  },
  {
    value: 99897,
    label: 'City of Austin - Renewables Portfolio Standard',
    states: ['tx']
  },
  {
    value: 99805,
    label: 'Interconnection Standards',
    states: ['tx']
  },
  {
    value: 993480,
    label:
      'Denton Municipal Electric - GreenSense Solar PV/Thermal Rebate Program',
    states: ['tx']
  },
  {
    value: 992946,
    label: 'Bryan Texas Utilities - Solar PV Rebate Program',
    states: ['tx']
  },
  {
    value: 99702,
    label: 'Hansford County Tax Abatement',
    states: ['tx']
  },
  {
    value: 993630,
    label:
      'New Braunfels Utilities - Energy Efficiency and Water Conservation Rebate Programs',
    states: ['tx']
  },
  {
    value: 993660,
    label:
      'AEP Texas - Commercial and Industrial Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 993661,
    label: 'AEP Texas Central Company - SMART Source Solar PV Rebate Program',
    states: ['tx']
  },
  {
    value: 993669,
    label: 'AEP Texas North Company - SMART Source Solar PV Rebate Program',
    states: ['tx']
  },
  {
    value: 993670,
    label: 'AEP (SWEPCO) - SMART Source Solar PV Program',
    states: ['tx']
  },
  {
    value: 992925,
    label: 'Austin Energy - Commercial New Construction Efficiency Rebates',
    states: ['tx']
  },
  {
    value: 993727,
    label: 'City of Sunset Valley - PV Rebate Program',
    states: ['tx']
  },
  {
    value: 993735,
    label: 'City of Sunset Valley - Solar Water Heating Rebate Program',
    states: ['tx']
  },
  {
    value: 993742,
    label: 'Renewable Energy Demonstration Pilot Program',
    states: ['tx']
  },
  {
    value: 993743,
    label: 'Department of Rural Affairs - Wind Energy for Desalination Program',
    states: ['tx']
  },
  {
    value: 992887,
    label: 'City of Houston - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 992885,
    label: 'City of Houston - Green Power Purchasing',
    states: ['tx']
  },
  {
    value: 992884,
    label: 'City of Dallas - Green Energy Purchasing',
    states: ['tx']
  },
  {
    value: 993825,
    label: 'AEP SWEPCO - SCORE Program',
    states: ['tx']
  },
  {
    value: 993827,
    label: 'AEP Texas Central Company - CitySmart Program',
    states: ['tx']
  },
  {
    value: 993828,
    label: 'AEP Texas Central Company - Commercial Solutions Program',
    states: ['tx']
  },
  {
    value: 993829,
    label: 'AEP Texas Central Company - SCORE Program',
    states: ['tx']
  },
  {
    value: 993830,
    label: 'AEP Texas North Company - CitySmart Program',
    states: ['tx']
  },
  {
    value: 993831,
    label: 'AEP (Central, SWEPCO and North) - Commercial Solutions Program',
    states: ['tx']
  },
  {
    value: 993832,
    label: 'AEP Texas North Company - SCORE Program',
    states: ['tx']
  },
  {
    value: 993833,
    label: 'CenterPoint Energy - SCORE and CitySmart Program',
    states: ['tx']
  },
  {
    value: 993834,
    label: 'CenterPoint Energy - SCORE Program',
    states: ['tx']
  },
  {
    value: 993835,
    label: 'Entergy Texas - CitySmart Program',
    states: ['tx']
  },
  {
    value: 993838,
    label: 'El Paso Electric Company - Residential Solutions Program',
    states: ['tx']
  },
  {
    value: 993840,
    label:
      'El Paso Electric Company - Small Business and Large Commercial Programs',
    states: ['tx']
  },
  {
    value: 992795,
    label: 'CPS Energy - Commercial Energy Efficiency Rebates',
    states: ['tx']
  },
  {
    value: 99530,
    label: 'Big Country Electric Coop - PV Water Pump Sales & Lease Program',
    states: ['tx']
  },
  {
    value: 994917,
    label: 'CoServ - Solar Energy Rebate',
    states: ['tx']
  },
  {
    value: 992794,
    label: 'CPS Energy - Solar PV Rebate Program',
    states: ['tx']
  },
  {
    value: 992797,
    label: 'CPS Energy - Solar Hot Water Rebate Program',
    states: ['tx']
  },
  {
    value: 992779,
    label: 'Advanced Clean Energy Project Grants',
    states: ['tx']
  },
  {
    value: 992766,
    label: 'ENERGY STAR Sales Tax Holiday for Energy-Efficient Products',
    states: ['tx']
  },
  {
    value: 992762,
    label: 'City of Austin - Green Power Purchasing',
    states: ['tx']
  },
  {
    value: 992749,
    label:
      'City of Austin - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 992741,
    label: 'City of Dallas - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 992730,
    label: 'Frisco - Municipal Green Building Program',
    states: ['tx']
  },
  {
    value: 992729,
    label:
      'City of Frisco - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 99517,
    label: 'Austin Energy - Home Energy Loans',
    states: ['tx']
  },
  {
    value: 993972,
    label: 'Austin Energy - Commercial Solar PV Incentive Program',
    states: ['tx']
  },
  {
    value: 99513,
    label: 'Austin Energy - Solar Loan Program',
    states: ['tx']
  },
  {
    value: 99511,
    label: 'Austin Energy - Solar Water Heating Rebate',
    states: ['tx']
  },
  {
    value: 993535,
    label:
      'PACE Financing (Local Option - Contractual Assessments for Energy Efficient Improvements)',
    states: ['tx']
  },
  {
    value: 99337,
    label: 'Mandatory Renewable Energy Educational Materials',
    states: ['tx']
  },
  {
    value: 9917413,
    label:
      'Texas State Energy Conservation Office - Innovative Energy Demonstration Program',
    states: ['tx']
  },
  {
    value: 994147,
    label: 'CPS Energy - Solartricity Producer Program',
    states: ['tx']
  },
  {
    value: 994176,
    label: 'Green Mountain Energy Renewable Rewards Program',
    states: ['tx']
  },
  {
    value: 994196,
    label: 'El Paso Electric Company - Solar PV Pilot Program',
    states: ['tx']
  },
  {
    value: 994228,
    label:
      'Bandera Electric Cooperative - Residential Heat Pump Rebate Program',
    states: ['tx']
  },
  {
    value: 9917415,
    label:
      'Texas State Energy Conservation Office - Texas Industries of the Future Program',
    states: ['tx']
  },
  {
    value: 9915772,
    label:
      'Brownsville Public Utilities Board - Customer Engineering-Energy Services',
    states: ['tx']
  },
  {
    value: 9917418,
    label: 'Entergy Texas - Datalink',
    states: ['tx']
  },
  {
    value: 9917433,
    label: 'Denton Municipal Electric - Load Profiler',
    states: ['tx']
  },
  {
    value: 9917434,
    label: 'Lower Colorado River Authority - Energy Services',
    states: ['tx']
  },
  {
    value: 9917437,
    label:
      'Texas Renewable Energy Industries Association - General Info & Links',
    states: ['tx']
  },
  {
    value: 994289,
    label: 'AEP SWEPCO - CitySmart Program',
    states: ['tx']
  },
  {
    value: 9921636,
    label: 'Rio Grande Electric Coop - Interconnection',
    states: ['tx']
  },
  {
    value: 994320,
    label: 'CPS Energy - Small Business Lighting Retrofit Program',
    states: ['tx']
  },
  {
    value: 994322,
    label:
      'City of San Antonio and CPS Energy - City Lights Small Business Energy Efficiency Program',
    states: ['tx']
  },
  {
    value: 992653,
    label:
      'Entergy Texas - SCORE, CitySmart, and Commercial Solutions Programs',
    states: ['tx']
  },
  {
    value: 992652,
    label:
      'Entergy Texas - Residential and Small Commercial Standard Offer Program',
    states: ['tx']
  },
  {
    value: 994350,
    label: 'Texas - Residential Energy-Efficient Appliance Rebates',
    states: ['tx']
  },
  {
    value: 992650,
    label:
      'CenterPoint Energy - Residential and Small Commercial Efficiency Program',
    states: ['tx']
  },
  {
    value: 992649,
    label:
      'CenterPoint Energy - Commercial and Industrial Energy Efficiency Programs',
    states: ['tx']
  },
  {
    value: 992648,
    label: 'Oncor Electric Delivery - Home Energy Efficiency Program (Texas)',
    states: ['tx']
  },
  {
    value: 992647,
    label: 'Oncor Electric Delivery - Energy Star Homes Program',
    states: ['tx']
  },
  {
    value: 992631,
    label:
      'Bryan Texas Utilities - Commercial Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 994363,
    label: 'CenterPoint Energy - ENERGY STAR Homes Efficiency Program',
    states: ['tx']
  },
  {
    value: 9921750,
    label: 'Entergy Louisiana - DataLink',
    states: ['tx']
  },
  {
    value: 994470,
    label: 'Garland Power & Light: Commercial Lighting Rebate Program',
    states: ['tx']
  },
  {
    value: 994480,
    label: 'AEP (Central and North) - Residential Energy Efficiency Programs',
    states: ['tx']
  },
  {
    value: 99335,
    label: 'Alternative Energy in New State Construction',
    states: ['tx']
  },
  {
    value: 992473,
    label:
      'San Antonio City Public Service (CPS Energy) - Renewable Portfolio Goal',
    states: ['tx']
  },
  {
    value: 992464,
    label: 'City of Austin - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 9915778,
    label: 'College Station Utilities - Energy Surveys',
    states: ['tx']
  },
  {
    value: 992315,
    label: 'Energy Efficiency Goals and Requirements for Public Entities',
    states: ['tx']
  },
  {
    value: 99334,
    label: 'Certification of Solar Collectors',
    states: ['tx']
  },
  {
    value: 9921793,
    label: 'Xcel Energy - Energy Design Assistance',
    states: ['tx']
  },
  {
    value: 992091,
    label:
      'Farmers Electric Cooperative - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 992090,
    label:
      'Guadalupe Valley Electric Cooperative - Conservation Plan 7 Loan Program',
    states: ['tx']
  },
  {
    value: 992089,
    label:
      'Magic Valley Electric Cooperative - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 9915786,
    label: 'Entergy Texas - Commercial Solutions Program',
    states: ['tx']
  },
  {
    value: 9921794,
    label: 'Xcel Energy - Online Energy Assessment',
    states: ['tx']
  },
  {
    value: 994587,
    label: 'City of Brenham - Net Metering',
    states: ['tx']
  },
  {
    value: 994593,
    label:
      'El Paso Electric Company - SCORE Program for Counties, Municipalities, and Schools',
    states: ['tx']
  },
  {
    value: 994594,
    label: 'AEP (Central and SWEPCO) - Coolsaver A/C Tune Up or Replacement',
    states: ['tx']
  },
  {
    value: 9921800,
    label: 'Xcel Energy - Energy Audits and Studies',
    states: ['tx']
  },
  {
    value: 994601,
    label:
      'Oncor Electric Delivery - Government and Education Facilities Program',
    states: ['tx']
  },
  {
    value: 994602,
    label: 'Oncor Electric Delivery - City and School Matching Grant Program',
    states: ['tx']
  },
  {
    value: 9915792,
    label: 'Garland Power & Light - Energy Audit',
    states: ['tx']
  },
  {
    value: 994622,
    label: 'Required Energy Efficiency Goals',
    states: ['tx']
  },
  {
    value: 9917695,
    label:
      'Brownsville Public Utilities Board - Customer Engineering-Energy Services',
    states: ['tx']
  },
  {
    value: 9915798,
    label: 'New Braunfels Utilities - Energy Audit',
    states: ['tx']
  },
  {
    value: 994658,
    label: 'City of Houston - Energy Efficiency Incentive Program',
    states: ['tx']
  },
  {
    value: 992088,
    label:
      'Pedernales Electric Cooperative - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 994720,
    label:
      'City of Houston - Property Tax Abatement for Green Commercial Buildings',
    states: ['tx']
  },
  {
    value: 994748,
    label:
      'City of San Antonio - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 994750,
    label:
      'City of San Antonio - Green Building Policy for Municipal Buildings',
    states: ['tx']
  },
  {
    value: 994751,
    label: 'City of San Antonio -Tax Abatement Scorecard Program',
    states: ['tx']
  },
  {
    value: 994770,
    label:
      'CoServ Electric Cooperative - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 994771,
    label:
      'CoServ Electric Cooperative - Commercial Energy Efficient Lighting Rebate Program',
    states: ['tx']
  },
  {
    value: 994788,
    label: 'CPS Energy - New Commercial Construction Incentives',
    states: ['tx']
  },
  {
    value: 994789,
    label: 'CPS Energy - New Residential Construction Incentives',
    states: ['tx']
  },
  {
    value: 9917705,
    label: 'Denton Municipal Electric - Commercial Energy Services',
    states: ['tx']
  },
  {
    value: 994792,
    label: 'City of Dallas - Green Building Expedited Plan Review',
    states: ['tx']
  },
  {
    value: 994793,
    label:
      'City of Dallas - Residential and Commercial Green Building Requirements',
    states: ['tx']
  },
  {
    value: 9921802,
    label: 'Xcel Energy - Small Business Lighting',
    states: ['tx']
  },
  {
    value: 994796,
    label:
      'New Braunfels Utilities - Residential Solar Water Heater Rebate Program',
    states: ['tx']
  },
  {
    value: 9917847,
    label: 'Kerrville Public Utility Board - Business Energy Audits',
    states: ['tx']
  },
  {
    value: 99327,
    label: 'Austin Energy - Net Metering',
    states: ['tx']
  },
  {
    value: 99288,
    label: 'Texas - Net Metering',
    states: ['tx']
  },
  {
    value: 9918961,
    label: 'Wharton County Electric Coop - Energy Audits',
    states: ['tx']
  },
  {
    value: 994864,
    label: 'City of Austin - Zoning Code',
    states: ['tx']
  },
  {
    value: 994880,
    label: 'Solar Rights',
    states: ['tx']
  },
  {
    value: 992087,
    label:
      'Tri-County Electric Cooperative - Energy Efficient Water Heater Rebate Program',
    states: ['tx']
  },
  {
    value: 9921803,
    label: 'Xcel Energy - Business Energy Advisor',
    states: ['tx']
  },
  {
    value: 994911,
    label:
      'Harris County - Property Tax Abatement for Green Commercial Buildings',
    states: ['tx']
  },
  {
    value: 994912,
    label: 'Harris County - Green Building Policy for County Buildings',
    states: ['tx']
  },
  {
    value: 994948,
    label: 'Magic Valley Electric Cooperative - ENERGY STAR Builders Program',
    states: ['tx']
  },
  {
    value: 992084,
    label:
      'United Cooperative Services - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 992039,
    label:
      'Denton Municipal Electric - Residential GreenSense Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 9918980,
    label: 'TXU Energy - iThermostat for Business',
    states: ['tx']
  },
  {
    value: 995008,
    label:
      'City of Friendswood - Property Tax Abatement for Green Commercial Buildings',
    states: ['tx']
  },
  {
    value: 9918981,
    label: 'TXU Energy - PowerReport',
    states: ['tx']
  },
  {
    value: 9919309,
    label: 'Garland Power & Light - Energy Depot for Business',
    states: ['tx']
  },
  {
    value: 9919311,
    label: 'TXU Energy PowerReport',
    states: ['tx']
  },
  {
    value: 992036,
    label:
      'CPS Energy (Electric) - Residential Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 9919314,
    label: 'AEP Texas Central Company - Commercial Solutions Program',
    states: ['tx']
  },
  {
    value: 995117,
    label: 'City of San Marcos - Distributed Generation Rebate Program',
    states: ['tx']
  },
  {
    value: 995118,
    label: 'City of San Marcos - Energy Efficient Home Rebate Program',
    states: ['tx']
  },
  {
    value: 992029,
    label:
      'College Station Utilities - Residential Energy Back II Rebate Program',
    states: ['tx']
  },
  {
    value: 992028,
    label: 'Bryan Texas Utilities - Appliance Loan Program',
    states: ['tx']
  },
  {
    value: 995126,
    label: 'AEP (SWEPCO) - Residential Energy Efficiency Programs',
    states: ['tx']
  },
  {
    value: 995139,
    label: 'Austin Energy - Value of Solar Residential Rate',
    states: ['tx']
  },
  {
    value: 995154,
    label: 'Austin Energy - Residential Solar Loan Program',
    states: ['tx']
  },
  {
    value: 9919316,
    label: 'AEP Texas North Company - Commercial Solutions Program',
    states: ['tx']
  },
  {
    value: 992026,
    label: 'Bryan Texas Utilities - Energy Efficiency Loan Program',
    states: ['tx']
  },
  {
    value: 992020,
    label: 'Austin Energy - Energy Miser Vending Products Program',
    states: ['tx']
  },
  {
    value: 995170,
    label: 'AEP (Central, SWEPCO and North) - SCORE Program for Schools',
    states: ['tx']
  },
  {
    value: 995171,
    label: 'AEP (Central and North) - CitySmart Program',
    states: ['tx']
  },
  {
    value: 995176,
    label: 'Sharyland Utilities - Commercial Standard Offer Program',
    states: ['tx']
  },
  {
    value: 995177,
    label: 'Sharyland Utilities - Residential Standard Offer Program',
    states: ['tx']
  },
  {
    value: 9919669,
    label: 'Mid South Synergy - Business Energy Advisor',
    states: ['tx']
  },
  {
    value: 992016,
    label: 'Austin Energy - Free Home Energy Improvements Program',
    states: ['tx']
  },
  {
    value: 992015,
    label: 'Austin Energy - Multi-Family Energy Efficiency Rebate Program',
    states: ['tx']
  },
  {
    value: 995221,
    label: 'City of Plano - Smart Energy Loan Program',
    states: ['tx']
  },
  {
    value: 9921806,
    label: 'Xcel Energy - Business Solutions',
    states: ['tx']
  },
  {
    value: 99727,
    label: 'Residential Energy Conservation Subsidy Exclusion (Corporate)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99729,
    label: 'Renewable Energy Production Incentive (REPI)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99722,
    label: 'USDA Rural Housing Service Loans',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991709,
    label: 'Federal Appliance Standards',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917041,
    label: 'The Hydraulic Institute',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917045,
    label: "Non-Ferrous Founders' Society - Energy Information",
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 992393,
    label: 'Energy Goals and Standards for Federal Agencies',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995681,
    label:
      'USDA - Rural Energy for America Program (REAP) Energy Audit and Renewable Energy Development Assistance (EA/REDA) Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99726,
    label: 'Deductions for Clean-Fuel Vehicles and Refueling Property',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99724,
    label: 'Deductions for Clean-Fuel Vehicles and Refueling Property',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 992510,
    label: 'Clean Renewable Energy Bonds (CREBs)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 992511,
    label: 'USDA - Rural Energy for America Program (REAP) Loan Guarantees',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99734,
    label: 'Renewable Electricity Production Tax Credit (PTC)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99736,
    label: 'Alcohol Fuel Credit',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99737,
    label: 'Small Business Administration Loan Programs',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99742,
    label: 'Energy-Efficient Mortgages',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995313,
    label: 'USDA - Biorefinery Assistance Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991045,
    label: 'Weatherization Assistance Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995631,
    label: 'FHA PowerSaver Loan Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9915956,
    label: 'E-Source - Business Energy Advisor',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9915955,
    label:
      'Association of Energy Services Professionals - Brown Bag Energy Seminars',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991060,
    label: 'Green Power Purchasing Goal for Federal Government',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99666,
    label: 'Residential Energy Conservation Subsidy Exclusion (Personal)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 994359,
    label: 'USDA - High Energy Cost Grant Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917967,
    label:
      'U.S. Department of Agriculture - Bioenergy Program for Advanced Biofuels',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99112,
    label:
      'Tax-Exempt Financing for Green Buildings, Renewable Energy & Brownfield Redevelopment',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9915954,
    label: 'Association of Energy Engineers - Energy Training Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991096,
    label: 'Value-Added Producer Grant Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9915953,
    label: 'TPC Trainco - Industrial Energy Efficiency Training',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9922035,
    label: 'Southeast Energy Efficiency Alliance (SEEA) - Resource Center',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917566,
    label:
      'U.S. Department of the Treasury - Payments for Specified Energy Property in Lieu of Tax Credits',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917544,
    label: 'U.S. Environmental Protection Agency - ENERGY STAR Training',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995780,
    label: 'Fannie Mae Green Initiative- Loan Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99669,
    label: 'Federal Excise Tax Exemption for Gasohol',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991235,
    label: 'Residential Renewable Energy Tax Credit',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99348,
    label: 'Conservation Security Program (CSP) Production Incentive',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 992774,
    label: 'Interconnection Standards for Small Generators',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9921219,
    label: 'CLEARresults',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9920736,
    label: 'Gaz Métropolitain & Co., LP - Feasibility Studies',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99676,
    label: 'Modified Accelerated Cost-Recovery System (MACRS)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99693,
    label: '2003 Climate Change Fuel Cell Buy-Down Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991271,
    label: 'Energy-Efficient Commercial Buildings Tax Deduction',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991272,
    label: 'Energy-Efficient New Homes Tax Credit for Home Builders',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9920513,
    label: 'North Carolina Solar Center - Education, Analysis, and Modeling',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991273,
    label: 'Energy-Efficient Appliance Manufacturing Tax Credit',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991274,
    label: 'Residential Energy Efficiency Tax Credit',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991280,
    label: 'Veterans Housing Guaranteed and Insured Loans',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 991616,
    label: 'Energy Goals and Standards for Federal Government',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99658,
    label: 'Business Energy Investment Tax Credit (ITC)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99700,
    label: 'HUD Energy Efficient Mortgages',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9921075,
    label: 'Dominion Hope - West Virginia - Business Energy Center',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99917,
    label: 'USDA - Rural Energy for America Program (REAP) Grants',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917056,
    label: 'Energy Sciences - Energy Management Services',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9916403,
    label:
      'Touchstone Energy Cooperatives - Commercial/Business Energy Advisor',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917051,
    label: 'Energy Solutions Center -  Industrial Energy Efficiency Consortium',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 993280,
    label: 'U.S. Department of Treasury - Renewable Energy Grants',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9916924,
    label:
      'National Center for Hydrogen Technology, University of North Dakota - Education and Outreach',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 993279,
    label: 'Qualifying Advanced Energy Manufacturing Investment Tax Credit',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917050,
    label: 'Edison Electric Institute - Energy Efficiency',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917049,
    label:
      'American Public Power Association - Energy Efficiency Resource Central',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99918,
    label: 'Tribal Energy Program Grant',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917047,
    label: 'Original Equipment Suppliers Association - Resources',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 993071,
    label: 'U.S. Department of Energy - Loan Guarantee Program',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995725,
    label: 'Weatherization Assistance Program (WAP)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995712,
    label: 'Low Income Home Energy Assistance Program (LIHEAP)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 9917039,
    label:
      'U.S. Environmental Protection Agency - ENERGY STAR Guidelines for Energy Management',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 993098,
    label: 'Qualified Energy Conservation Bonds (QECBs)',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 99718,
    label: 'Energy Star Financing and Mortgages',
    states: ['ma', 'nj', 'tx', 'ct']
  },
  {
    value: 995316,
    label: 'USDA - Repowering Assistance Biorefinery Program',
    states: ['ma', 'nj', 'tx', 'ct']
  }
].filter(incentive => available.includes(incentive.value));
